import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { useOnboarding } from '@/pages/Onboarding/context';
import { SAFEWORD_CHOICE_OPTIONS } from '@/pages/Onboarding/options/SafewordChoice/SAFEWORD_CHOICE_OPTIONS';
import { getSafewordChoiceTitleById } from '@/pages/Onboarding/options/SafewordChoice/utils/getSafewordChoice';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { OwnAiTitle } from '../../components/Title';
import { LayoutDataType } from '../../types';

import { PageStyles } from './SafewordChoice.styles';

export const ScreenSafewordChoice: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Safeword Choice',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const safewordChoice = form.watch('safeword_choice');

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['safeword_choice']>,
  ) => {
    form.setValue('safeword_choice', option.id);
  };

  const handleNextStep = (): void => {
    userService.createOrUpdate({
      onboarding_data: {
        safeword_choice: getSafewordChoiceTitleById(safewordChoice),
      },
    });
    wizard.nextStep();
  };

  return (
    <PageStyles background={'domination'}>
      <OnboardingNavigation />
      <OwnAiTitle>
        Do you want a safeword... or are you ready to surrender completely?
      </OwnAiTitle>
      <IonContent>
        <OnboardingOptionsList>
          {SAFEWORD_CHOICE_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={safewordChoice === option.id}
              control={form.control}
              option={option}
              name="safeword_choice"
              key={option.id}
              onChange={() => handleSelect(option)}
              TEST_ID={`safeword-choice-${option.id}`}
              theme={'domination'}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>

      {safewordChoice && (
        <OnboardingFooter
          onContinue={handleNextStep}
          buttonColor={'red-gradient'}
          buttonRadius={'sm'}
          buttonSize={'medium'}
          buttonClassName={'page-footer'}
        />
      )}
    </PageStyles>
  );
};
